import React from 'react'
import Model from './Model'
import Overlay from './Overlay'

function SecondBanner() {
  return (
    <>
    
    <Model/>
    <Overlay/>
    </>
  )
}

export default SecondBanner